import { Link } from 'react-router-dom';
import { Heart } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';

export default function PublicDonateThanks() {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <Card className="w-full max-w-md">
        <CardContent className="py-8 text-center space-y-4">
          <Heart className="h-10 w-10 mx-auto text-primary" />
          <h1 className="text-2xl font-bold">Thank you!</h1>
          <p className="text-sm text-muted-foreground">
            Your donation supports United Wrestling Club's coaches, facilities, and the athletes who can't afford full membership on their own.
          </p>
          <Button asChild variant="outline"><Link to="/">Back to home</Link></Button>
        </CardContent>
      </Card>
    </div>
  );
}
